import styled from "styled-components";

export const Container = styled.div`
  background-color: #F5F5F5;
  padding: 24px;
  width: 100%;
`

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1448px;

  h5 {
    color: #7E8691;
    font-size: 24px;
    font-weight: 700;
    line-height: 27.58px;
    margin-bottom: 10px;
    text-align: center;
  }
`

export const Content = styled.div`
  overflow-y: visible;
  overflow-x: scroll;
  height: max-content;
  padding-bottom: 16px;
  width: 100%;

  &::-webkit-scrollbar {
    scrollbar-width: thin;

    @media (max-width: 768px) {
      display: none;
    }
  }

  &::-webkit-scrollbar-thumb {
    background-color: #4CC5B6;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #00A687;
  }
`

export const ScrollContent = styled.div`
  align-items: center;
  display: flex;
  gap: 32px;
  justify-content: center;

  @media screen {
    width: max-content;
  }
`